


















































import { Component, Emit, Prop, Watch } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import AddJob from '@/components/add business objects/addJob.vue';
import {
	AllEntities,
	FaultSymptomsApi,
	Org,
	OrgsApi,
	Product,
	ProductsApi,
	ProductSimProJob,
	SimproApi,
	SimproJobStoryParameters,
	User,
} from '@/api';
import Vue from 'vue';
import { ParsingUtil } from '@/common/ParsingUtil';
import Toast from '@/components/display/toast.vue';

@Component({
	components: { AddJob },
	mixins: [validationMixin],
})
export default class EditJobModalsContainer extends Vue {
	@Prop({ required: true })
	public product!: Product;

	@Prop()
	public partnerOrgs: Org[] | undefined;

	@Prop({ required: true })
	public orgId!: number;

	@Prop({ required: true })
	public jobId!: number;

	public renderKey = 0;

	public contactableUsers: User[] = [];
	public jobStoryParameters: SimproJobStoryParameters | null = null;

	public faultReasonOptions: { text: string; value: any }[] = [];
	public sensorFaultReasonOptions: { text: string; value: any }[] = [];
	public transceiverFaultReasonOptions: { text: string; value: any }[] = [];

	private productApi: ProductsApi = new ProductsApi();
	private orgApi: OrgsApi = new OrgsApi();
	private faultSymptomsApi: FaultSymptomsApi = new FaultSymptomsApi();
	private simproApi: SimproApi = new SimproApi();
	private toast: Toast = new Toast();

	public async created() {
		await this.loadContactableUsers();
		await this.loadFaultSymptoms();
		await this.changeJobId();
	}

	private async loadFaultSymptoms() {
		try {
			const response = await this.faultSymptomsApi.getFaultSymptoms();
			const faultSymptoms = (response.data.data ?? []).filter(
				x => x.productType == null || x.productType == this.product.type,
			);
			this.faultReasonOptions = (
				faultSymptoms.filter(x => x.entityType == AllEntities.Products) ?? []
			).map(x => ({ text: x.name, value: x.id }));
			this.sensorFaultReasonOptions = (
				faultSymptoms.filter(x => x.entityType == AllEntities.Sensors) ?? []
			).map(x => ({ text: x.name, value: x.id }));
			this.transceiverFaultReasonOptions = (
				faultSymptoms.filter(x => x.entityType == AllEntities.Transceivers) ?? []
			).map(x => ({ text: x.name, value: x.id }));
		} catch (e) {
			console.log('Error loading fault symptoms:', e);
		}
	}

	public async loadContactableUsers() {
		if (this.product.orgId == null) return;
		const productId: number | null = ParsingUtil.parseId(this.$route.params.productId);
		if (productId == null) {
			return;
		}
		try {
			const productData = await this.productApi.getProductById(productId, {
				params: { include: 'users' },
			});
			const orgData = await this.orgApi.getOrgUsers(this.product.orgId);
			const compiledUsers = [
				...((<Product & { users: any[] }>productData.data).users ?? []),
				...(orgData.data.data ?? []),
			];
			const uniqueIds = [...new Set(compiledUsers.map(user => user.id))];
			this.contactableUsers = uniqueIds.map(id => compiledUsers.find(user => user.id === id));
		} catch (e) {
			console.log(e);
		}
		this.reRender();
	}

	public loadJob() {
		this.$emit('loadJob');
	}

	public reRender() {
		this.renderKey > 0 ? this.renderKey-- : this.renderKey++;
	}

	@Watch('jobId')
	public async changeJobId() {
		this.jobStoryParameters =
			(await this.simproApi.getJobStoryParameters(this.jobId))?.data?.data ?? null;
		if (this.jobStoryParameters == null) {
			this.toast.makeToast(
				'There was an issue getting parameters for this job. This can occur on older jobs',
				'Error',
				'danger',
			);
			return;
		}
	}

	@Emit('jobStoryUpdated')
	public jobStoryUpdated(): void {}
}
